import actionTypes from "./actionTypes";
import api from "./api";
export default {
    getTaskStatistics: (scope, params = {}) => ({
        type: actionTypes.GET_TASK_STATISTICS,
        payload: {
            promise: () => api.getTaskStatistics(params)
        },
        meta: scope,
        scope: `${actionTypes.GET_TASK_STATISTICS}_${scope}`
    }),
    setTaskStatisticsFilterParams: (scope, params) => ({
        type: actionTypes.SET_TASK_STATISTICS_FILTER_PARAMS,
        params,
        meta: scope
    }),
    clearAllTaskStatisticsFilterParams: (scope) => ({
        type: actionTypes.CLEAR_ALL_TASK_STATISTICS_FILTER_PARAMS,
        meta: scope
    })
};
